/**
 * Strips the `schaefflerAsmAgent` marker from a URL before redirecting after ASM
 * close/logout. Ports the exact replacement chain from the legacy
 * legacy ASM close handler so all three placements are
 * removed: `&schaefflerAsmAgent`, `?schaefflerAsmAgent&` and `?schaefflerAsmAgent`.
 */
export function stripAsmAgentParam(url: string): string {
  return url.replace("&schaefflerAsmAgent", "").replace("?schaefflerAsmAgent&", "?").replace("?schaefflerAsmAgent", "");
}
